import React, { Component } from 'react';
import { HashRouter as Router, Route, Link } from "react-router-dom";
import Login from "./login/Login";
import Main from "./main/Main";
import TestComponent from "./util/TestComponent";

class AppRouter extends Component {
    render() {
        return (
            <Router>
                <div style={{
                    height: 'calc(100% - 65px)'
                }}>
                    <Route path="/" exact component={Login} />
                    <Route path="/login" exact component={Login} />
                    <Route path="/app/" exact component={Main} />
                    <Route path="/testComponent/" exact component={TestComponent} />
                </div>
            </Router>
        );
    }
}

export default AppRouter;
